<template>
    <table class="table table-bordered table-striped table-vcenter dataTable">
        <thead>
            <tr>
                <th>Name</th>
                <th style="width:5%">Type</th>
                <th style="width:5%">Size</th>
                <th style="width:15%">Uploaded</th>
                <th style="width:15%">Updated</th>
                <th style="width:10%"></th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script>
import { createApp } from 'vue';
import { Eventbus } from '@/components/eventbus';
import ClassicsFilesEditTitle from './../files/editTitle.vue';

export default {
    props: {
        ajaxUrl: String,
        routes: Object,
    },

    mounted: function () {
        let table = window.jQuery(this.$el).DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[0, 'asc']],
            columns: [
                {
                    data: 'title',
                    render: (data, type, row) => {
                        return `<classics-files-edit-title current-title="${data || row.filename}" placeholder="${row.filename}" uuid="${row.uuid}" route="${this.routes.updateTitle}" />`;
                    }
                },
                {
                    data: 'extension',
                },
                {
                    data: 'size',
                },
                {
                    data: 'created_at',
                },
                {
                    data: 'updated_at',
                },
                {
                    data: 'actions',
                },
                {
                    data: 'filename',
                    visible: false,
                },
                {
                    data: 'uuid',
                    visible: false,
                },
            ],
            drawCallback: () => {
                let n = 0;
                for (const el of this.$el.querySelectorAll('classics-files-edit-title')) {
                    const tag = el.localName;
                    const app = createApp({
                        template: el.outerHTML,
                        name: `${tag} ${++n}`,
                    });
                    app.component(tag, ClassicsFilesEditTitle);
                    app.mount(el);
                }
            }
        });

        document.getElementById('vehicle-files-tab').addEventListener('shown.bs.tab', () => {
            this.$el.removeAttribute('style');
            table.columns.adjust();
        });

        Eventbus.on('files-table-refresh', () => {
            table.ajax.reload(null, false);
        });
    }
}
</script>
